import React, { Component, Context } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import clsx from "clsx";
import { IPeerSupportActionDispatches, mapPeerSupportDispatchToProps } from "../../../redux/actions/peerSupport";
import { IPeerSupportState, mapPeerSupportStateToProps } from "../../../redux/reducers/peerSupport";
import LayoutContext, { ILayoutContext } from "../../../contexts/layout/LayoutContext";
import { IPSFacility, PSRole, getPSRole } from "../../../models/peer-support";
import UILoader from "../../ui/UILoader";
import FacilitiesList from "./FacilitiesList";
import { FacilitiesHeader } from "./FacilitiesHeader";
import { FacilityDetail } from "./FacilityDetail";
import { withAuth, IAuthProps } from "../../../laco-common/auth/AuthContext";
import ClientFirebase from "../../../laco-common/firebase/web";
import { IS_EMBED } from "..";
const queryString = require("query-string");

type FacilitiesState = {
	loading: boolean;
	searchQuery: string;
	idToDelete: string;
};

const queryFacility = (facility: IPSFacility, queries: string[], userRole: PSRole): boolean => {
	let result: boolean = false;
	queries.forEach((q: string) => {
		const query: string = q?.trim();
		if (
			facility.name.toLowerCase().includes(query) ||
			facility.phone.toLowerCase().includes(query) ||
			(facility.resources || []).find((resource: string) => resource.toLowerCase().includes(query))
		) {
			result = true;
			if (result) return true;
		}
		if (facility.address.formatted_address.toLowerCase().includes(query)) {
			result = true;
			return true;
		}
		return result;
	});
	return result;
};

class Facilities extends Component<
	IPeerSupportActionDispatches & IPeerSupportState & RouteComponentProps & IAuthProps,
	FacilitiesState
> {
	private queryStringQuery: string = "";
	static contextType: Context<ILayoutContext> = LayoutContext;

	state = {
		loading: true,
		searchQuery: "",
		idToDelete: undefined,
	};

	get facilities(): IPSFacility[] {
		const userRole: PSRole = getPSRole(this.props.authContext, ClientFirebase);
		if (this.state.searchQuery) {
			const q: string = this.state.searchQuery.toLowerCase();
			const joinQuery: string[] = q.split(",");
			return this.props.facilities.filter((facility: IPSFacility) =>
				queryFacility(facility, joinQuery, userRole)
			);
		}
		return this.props.facilities || [];
	}

	componentDidMount() {
		const parsed = queryString.parse(this.props.location.search);
		if (parsed && parsed.q) {
			this.setState({ searchQuery: parsed.q });
			this.queryStringQuery = parsed.q;
			// Geocode.fromLatLng(parsed.lat, parsed.lng).then(
			// 	(response) => {
			// 		const address: Place = response.results[0];
			// 		const q: string = getZipCode(address);
			//
			// 		this.setState({ searchQuery: q });
			// 		this.queryStringQuery = q;
			// 	},
			// 	(error) => {
			// 		console.error(error);
			// 	}
			// );
		}
		this.props.loadFacilities().then(() => {
			this.setState({ loading: false });
		});
	}

	deleteFacility(facility: IPSFacility) {
		console.log("deleteFacility:", facility);
		return this.props.deleteFacility(facility).then(() => {
			this.setState({ idToDelete: facility.id });
			setTimeout(() => {
				this.setState({ idToDelete: undefined });
			}, 300);
		});
	}

	render() {
		if (this.state.loading) return <UILoader display={true} />;
		// const userRole: PSRole = getPSRole(this.props.authContext);
		// check if it's a detail page
		const arr = this.props.location.pathname.split("/");
		const facilityId: string = arr.length ? arr[arr.length - 1] : undefined;
		let facility: IPSFacility;
		if (facilityId && facilityId !== "facilities") {
			facility = this.props.facilities.find((f: IPSFacility) => f.id === facilityId);
			if (facility)
				return (
					<div className="animated fadeInRight fast-1">
						<FacilityDetail
							facility={facility}
							onEditFacility={(data, id) => this.props.editFacility(data, id)}
							onDeleteFacility={(data) => this.deleteFacility(data)}
						/>
					</div>
				);
		}

		return (
			<div className={clsx(!IS_EMBED && "container", IS_EMBED && "p-2", "my-4 pb-2")}>
				<FacilitiesHeader
					defaultValue={this.queryStringQuery}
					onSearch={(val) => this.setState({ searchQuery: val })}
					addFacility={(data) => this.props.addFacility(data)}
				/>
				{this.state.loading && <UILoader display={true} />}
				{!this.state.loading && (
					<FacilitiesList
						facilities={this.facilities}
						idToDelete={this.state.idToDelete}
						onEditFacility={(data, id) => this.props.editFacility(data, id)}
						onDeleteFacility={(data) => this.deleteFacility(data)}
					/>
				)}
			</div>
		);
	}
}

export default connect<IPeerSupportState, IPeerSupportActionDispatches>(
	mapPeerSupportStateToProps,
	mapPeerSupportDispatchToProps
)(withRouter(withAuth(Facilities)));
